import { ReportsFilters } from './ReportsFilter';

export const ReportsMain = () => {
  return <ReportsFilters />;
};
